module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lQPad"))).then(() => parcelRequire('d0iPb'));